/*******Using Localstorage instead of cookie*********/
const Cookie = () => {

    var currentTimeInSeconds=Math.floor(Date.now()/1000); //unix timestamp in seconds

    function generateToken(characters) {
        var text = "";
        var possible = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      
        for (var i = 0; i < characters; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));
      
        return text;
    }

    var ciisummitCookie = localStorage.getItem('_ciisummit');
    if(!ciisummitCookie){
        /******setcookie in localstorage******/
        localStorage.setItem('_ciisummit', generateToken(15)+currentTimeInSeconds+generateToken(15));
    }

}

export default Cookie;